import {
  Accordion,
  AccordionItem,
  Column,
  Dropdown,
  Row,
} from 'carbon-components-react';
import PublicImage from 'src/common/components/PublicImage';
import '../Assessments/index.scss';
import { StepProps } from '../../../lib/interfaces';
import { useEffect, useState } from 'react';
import { defaultValues, segmentsTrack } from '../../../constants/default';
import { useSmallBreakpoint } from 'src/common/hooks/widgets/useBreakpoint';

const Step1 = ({
  postObj,
  setPostObj,
  setIsRequired,
  useTranslation,
}: StepProps) => {
  const capacties = defaultValues('capacity', useTranslation) || [];
  const [capactiesItems, setCapactiesItems] = useState([]);

  const onChangeCapacity = (e: number, key: string) => {
    postObj[key] = e;
    if (key === 'capacity') {
      setIsRequired?.(!!e ? false : true);
      postObj['capacityOpt'] = '';
      getOptList();
    }
    setPostObj((prevFlags: any) => {
      const updatedFlags = Object.assign({}, prevFlags, {
        [key]: e,
        capacityOpt: key === 'capacity' ? '' : e,
      });
      return updatedFlags;
    });
  };

  const getOptList = () => {
    const capactiesObj = Object.assign(
      [],
      capacties.map((e: any) => ({
        ...e,
        disabled:
          postObj.hasOwnProperty('capacity') && postObj.capacity.id > e.id,
      })),
    );
    setCapactiesItems(capactiesObj);
  };

  useEffect(() => {
    if (postObj.hasOwnProperty('capacity') && postObj.capacity.id) {
      getOptList();
    }
  }, []);

  const segment = (evtKey = '') => {
    segmentsTrack(evtKey, 'Assessment Step 1 Page');
  };
  const isSmall = useSmallBreakpoint('560px');

  return (
    <div className="bx--row fixHeight">
      <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-16 bx--col-padding border-lr p-t-14">
        <div className="slide_text">{useTranslation('step1_para')}</div>
        {isSmall && (
          <div className="bx--col-md-8 bx--col-sm-4 p-b-0">
            <PublicImage
              imgPath={'images/flash--storage.svg'}
              widgetId="solution-advisor"
              width="100%"
              height="100%"
              alt="animation-image"
              className="screen small-screen"
            />
          </div>
        )}
        <Accordion
          size="sm"
          className="interactive-widget__accordion p-t-accordian p-t-16"
        >
          <AccordionItem
            title={useTranslation('step1_accordion_title')}
            onHeadingClick={() => segment('Accordian heading click')}
            className="p-b-0"
            open
          >
            <div className="b-b-1">
              <Row>
                <Column sm={16} md={16} lg={16}>
                  <Dropdown
                    id="default"
                    size="sm"
                    light
                    direction={isSmall ? 'top' : 'bottom'}
                    titleText={useTranslation('step1_accordion_dd1')}
                    label={useTranslation('step_choose_option')}
                    items={capacties}
                    onChange={({ selectedItem }) => {
                      onChangeCapacity(selectedItem, 'capacity');
                      segment('Today Capacity Selected');
                    }}
                    selectedItem={postObj['capacity']}
                    itemToString={(item) => (item ? item.text : '')}
                  />
                </Column>
              </Row>
            </div>
            <div className="bx--col-padding p-b-0">
              <Row>
                <Column sm={16} md={16} lg={16}>
                  <Dropdown
                    id="default"
                    size="sm"
                    light
                    direction="top"
                    titleText={useTranslation('step1_accordion_dd2')}
                    label={useTranslation('step_choose_option')}
                    items={capactiesItems}
                    selectedItem={postObj['capacityOpt']}
                    onChange={({ selectedItem }) => {
                      onChangeCapacity(selectedItem, 'capacityOpt');
                      segment('Lifecycle Capacity Selected');
                    }}
                    itemToString={(item) => (item ? item.text : '')}
                  />
                </Column>
              </Row>
            </div>
          </AccordionItem>
        </Accordion>
      </div>
      {!isSmall && (
        <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-16 bx--col-padding p-t-14">
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4 p-b-0">
              <PublicImage
                imgPath={'images/flash--storage.svg'}
                widgetId="solution-advisor"
                width="100%"
                height="100%"
                alt="animation-image"
                className="screen"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step1;
